import * as React from 'react';
import {BrowserRouter, Route, Switch} from 'react-router-dom';
import './App.css';
import {AdminArea} from "./component/area/AdminArea";
import {Login} from "./screen/admin/account/Login";
import {Home} from "./screen/home/Home";
import {News} from "./screen/news/News";
import {NewsDetail} from "./screen/news/NewsDetail";
import {Announcement} from "./screen/announcement/Announcement";
import {AnnouncementDetail} from "./screen/announcement/AnnouncementDetail";
import {Agenda} from "./screen/agenda/Agenda";
import {AgendaDetail} from "./screen/agenda/AgendaDetail";
import {Gallery} from "./screen/gallery/Gallery";
import {VillageOrganization} from "./screen/village-organization/VillageOrganization";
import {VillageOrganizationDetail} from "./screen/village-organization/VillageOrganizationDetail";
import {VoStaff} from "./screen/village-organization/VoStaff";
import {VoDusun} from "./screen/village-organization/VoDusun";
import {VoDusunDetail} from "./screen/village-organization/VoDusunDetail";
import {SocietyReport} from "./screen/society-report/SocietyReport";
import {SocietyReportDetail} from "./screen/society-report/SocietyReportDetail";
import {SubOrganizationDetail} from "./screen/village-organization/sub-organization/SubOrganizationDetail";
import {CitizenReportSuccess} from "./screen/society-report/CitizenReportSuccess";

interface IProps {
    componentName?: string;
}

interface IState {
    isOpen: boolean;
}

class App extends React.Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);

        this.state = {
            isOpen: false
        };
    }

    public render() {
        return (
            <BrowserRouter>

                <Switch>
                    <Route exact={true} path='/' component={Home} />
                    <Route path='/berita' component={News} />
                    <Route path='/berita/:detail' component={NewsDetail} />
                    <Route path='/pengumuman' component={Announcement} />
                    <Route path='/pengumuman/:detail' component={AnnouncementDetail} />
                    <Route path='/agenda' component={Agenda} />
                    <Route path='/agenda/:detail' component={AgendaDetail} />
                    <Route path='/galeri' component={Gallery} />
                    <Route path='/organisasi-desa' component={VillageOrganization} />
                    <Route path='/organisasi-desa/:detail' component={VillageOrganizationDetail} />
                    <Route path='/staff-desa' component={VoStaff} />
                    <Route path='/dusun' component={VoDusun} />
                    <Route path='/dusun/:detail' component={VoDusunDetail} />
                    <Route path='/dusun/:detail/organisasi/:subOrganization' component={SubOrganizationDetail} />
                    <Route path='/aspirasi-pengaduan' component={SocietyReport} />
                    <Route path='/aspirasi-pengaduan/:detail' component={SocietyReportDetail} />
                    <Route path='/success-report' component={CitizenReportSuccess} />
                    <Route path='/login' component={Login} />
                    <Route path='/admin' component={AdminArea} />

                </Switch>
            </BrowserRouter>
        );
    }

}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx